import { IAddress, IAddressSubscription, IDeposit, IFiat, ISpotRate, IWallet, IWithdraw } from '@libs/interfaces';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IUserWallet } from './model';

export const selectWalletFeat = createFeatureSelector<Readonly<IUserWallet>>('wallet');
export const selectWallet = createSelector(selectWalletFeat, (userWallet: IUserWallet): IWallet => userWallet?.wallet);
export const selectWallets = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): IWallet[] => userWallet.wallets,
);
export const selectBalance = createSelector(selectWalletFeat, (userWallet: IUserWallet): number => userWallet.balance);
export const selectDisplayFiat = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): boolean => userWallet.displayFiat,
);
export const selectBaseCurrency = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): IFiat => userWallet.baseCurrency,
);
export const selectSpots = createSelector(selectWalletFeat, (userWallet: IUserWallet): ISpotRate[] => userWallet.spots);
export const selectOnRamperUrl = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): string => userWallet.onRamperUrl,
);
export const selectMetamaskConnected = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): boolean => userWallet.metamask.connected,
);
export const selectMetamaskLocked = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): boolean => userWallet.metamask.locked,
);
export const selectMetamaskAddress = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): string => userWallet.metamask.address,
);
export const selectMetamaskWallet = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): string => userWallet.metamask.wallet,
);
export const selectMetamaskBalance = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): string => userWallet.metamask.balance,
);
export const selectMetamaskAsProvider = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): boolean => userWallet.metamask.asProvider,
);
export const selectWithdraw = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): IWithdraw => userWallet.withdraw,
);

export const selectAddress = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): IAddress => userWallet.address,
);
export const selectAddressSubscription = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): IAddressSubscription => userWallet.subscription,
);
export const selectPendingDeposits = createSelector(
  selectWalletFeat,
  (userWallet: IUserWallet): IDeposit[] => userWallet.pendingDeposits,
);
